import React from 'react';

export class HamburgerMenuIcon extends React.Component {
  render(){
    var color = this.props.color ? this.props.color : "#141414";

    return (
      <svg onClick={this.props.onClick} className={`svg hamburger-menu ${this.props.className || ''}`} width="25px" height="21px" viewBox="0 0 25 21">
        <g fill={color}>
          <rect id="Rectangle-21" x="0" y="0" width="25" height="3" rx="0.5"></rect>
          <rect id="Rectangle-21-Copy" x="0" y="9" width="25" height="3" rx="0.5"></rect>
          <rect id="Rectangle-21-Copy-2" x="0" y="18" width="25" height="3" rx="0.5"></rect>
        </g>
      </svg>
    )
  }
}
